"use client";

import { useEffect, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { Button } from "@/components/ui/button";
export default function Reflections() {
  const prefersReducedMotion = useReducedMotion();
  const quotes = [{
    text: "Saw this young man washing a car on my way home. I stopped to ask about his service and price. He did not disappoint! He came to my house and left my son's car looking like brand new. His work is excellent and very affordable. I highly recommend his services. Definitely will be contacting him again.",
    attribution: "KARRISA LAO"
  }, {
    text: "Muy feliz con su servicio, muy profesional lo recomiendo 10/10.",
    attribution: "RENEIRA MARTINEZ"
  }, {
    text: "Excelente servicio, muy profesional. El resultado superó mis expectativas.",
    attribution: "ANYELAINE LAZO"
  }];
  const [activeIndex, setActiveIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  useEffect(() => {
    if (prefersReducedMotion || isPaused) return;
    const id = window.setInterval(() => {
      setActiveIndex(i => (i + 1) % quotes.length);
    }, 8000);
    return () => window.clearInterval(id);
  }, [isPaused, prefersReducedMotion, quotes.length]);
  const activeQuote = quotes[activeIndex];
  const words = activeQuote.text.split(" ");
  return <section data-section-id="28518" id="client-reflections" className="relative overflow-hidden bg-background text-foreground py-24 md:py-44">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.04]" style={{
      backgroundImage: "radial-gradient(ellipse at center, transparent 0%, transparent 40%, hsl(41 62% 62% / 0.6) 40.5%, transparent 41%), radial-gradient(ellipse at center, transparent 0%, transparent 55%, hsl(41 62% 62% / 0.6) 55.5%, transparent 56%), radial-gradient(ellipse at center, transparent 0%, transparent 70%, hsl(41 62% 62% / 0.6) 70.5%, transparent 71%)",
      backgroundSize: "1200px 1200px",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat"
    }} />

      {}
      <motion.div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-1/2 -z-0 h-[600px] w-[600px] -translate-x-1/2 -translate-y-1/2 rounded-lg" style={{
      background: "radial-gradient(circle, hsl(41 62% 62% / 0.14) 0%, transparent 60%)"
    }} animate={prefersReducedMotion ? undefined : {
      x: [-30, 30, -30],
      y: [-20, 20, -20]
    }} transition={{
      duration: 24,
      repeat: Infinity,
      ease: "easeInOut"
    }} />

      <div className="relative z-10 mx-auto flex flex-col items-center px-5 md:px-8" style={{
      maxWidth: "720px"
    }} onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} onFocus={() => setIsPaused(true)} onBlur={() => setIsPaused(false)}>
        {}
        <div className="flex items-center justify-center gap-4">
          <span aria-hidden="true" className="block h-px" style={{
          width: "24px",
          backgroundColor: "hsl(41 62% 62%)"
        }} />
          <span className="font-sans uppercase" style={{
          color: "hsl(38 14% 68%)",
          fontSize: "clamp(0.68rem, 0.75vw, 0.78rem)",
          letterSpacing: "0.28em",
          fontWeight: 500,
          lineHeight: 1.2
        }}>
            Testimonials
          </span>
          <span aria-hidden="true" className="block h-px" style={{
          width: "24px",
          backgroundColor: "hsl(41 62% 62%)"
        }} />
        </div>

        {}
        <div className="h-16 md:h-24" aria-hidden="true" />

        {}
        <div aria-live="polite" aria-atomic="true" className="relative flex min-h-[220px] w-full items-center justify-center md:min-h-[280px]">
          <AnimatePresence mode="wait">
            <motion.blockquote key={activeIndex} initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} transition={{
            duration: prefersReducedMotion ? 0 : 0.4,
            ease: [0.22, 1, 0.36, 1]
          }} className="font-serif italic text-center" style={{
            color: "hsl(38 32% 92%)",
            fontSize: "clamp(1.5rem, 2.2vw, 2.25rem)",
            fontWeight: 400,
            letterSpacing: "-0.005em",
            lineHeight: 1.15
          }}>
              <span aria-hidden="true" className="mr-3 not-italic" style={{
              color: "hsl(41 62% 62%)"
            }}>
                {"\u2014"}
              </span>
              {prefersReducedMotion ? <span>{activeQuote.text}</span> : words.map((word, i) => <motion.span key={`${activeIndex}-${i}`} data-index={i} initial={{
              opacity: 0,
              y: 40,
              filter: "blur(8px)"
            }} animate={{
              opacity: 1,
              y: 0,
              filter: "blur(0px)"
            }} transition={{
              duration: 1.0,
              delay: 0.4 + i * 0.08,
              ease: [0.22, 1, 0.36, 1]
            }} className="inline-block">
                    {word}
                    {i < words.length - 1 ? "\u00A0" : ""}
                  </motion.span>)}
              <span aria-hidden="true" className="ml-3 not-italic" style={{
              color: "hsl(41 62% 62%)"
            }}>
                {"\u2014"}
              </span>
            </motion.blockquote>
          </AnimatePresence>
        </div>

        {}
        <div className="h-10 md:h-12" aria-hidden="true" />

        {}
        <div className="min-h-[24px] w-full text-center">
          <AnimatePresence mode="wait">
            <motion.p key={`attr-${activeIndex}`} initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} transition={{
            duration: prefersReducedMotion ? 0 : 0.5,
            delay: prefersReducedMotion ? 0 : 0.6,
            ease: [0.22, 1, 0.36, 1]
          }} className="font-sans uppercase" style={{
            color: "hsl(38 14% 68%)",
            fontSize: "clamp(0.68rem, 0.75vw, 0.78rem)",
            letterSpacing: "0.28em",
            lineHeight: 1.2,
            fontWeight: 500
          }}>
              {activeQuote.attribution}
            </motion.p>
          </AnimatePresence>
        </div>

        {}
        <div className="h-10 md:h-12" aria-hidden="true" />

        {}
        <div className="flex items-center justify-center gap-4" role="tablist" aria-label="Client reviews">
          {quotes.map((_, i) => {
          const isActive = i === activeIndex;
          return <Button key={i} data-index={i} type="button" variant="ghost" size="icon" role="tab" aria-selected={isActive} aria-current={isActive ? "true" : undefined} aria-label={`Show review ${i + 1}`} onClick={() => setActiveIndex(i)} className="group relative flex h-11 w-11 items-center justify-center bg-transparent p-0 hover:bg-transparent focus-visible:ring-0" style={{
            minWidth: "44px",
            minHeight: "44px"
          }}>
                <span aria-hidden="true" className="block transition-all duration-300 ease-out" style={{
              height: "1px",
              width: isActive ? "40px" : "24px",
              backgroundColor: isActive ? "hsl(41 62% 62%)" : "hsl(258 14% 14%)"
            }} />
              </Button>;
        })}
        </div>
      </div>
    </section>;
}